import { gql } from '@common/hooks';

/**
 * Client-only schema for @client fields (header, menu).
 * Used by CodeGen; previously provided via typeDefs on ApolloClient.
 */

export const clientSchemaString = gql`
  directive @client on FIELD

  type Breadcrumb {
    name: String!
    path: String!
    privateInfo: Boolean
  }

  type Header {
    breadcrumbs: [Breadcrumb]
  }

  type Menu {
    active: String
  }

  extend type Query {
    header: Header!
    menu: Menu!
  }
`;
